module.exports = __webpack_public_path__ + "static/szkoleniowa-3-4c3f06931483d4d5d19b10d881fc1f0d.jpg";